import React from 'react'
import { Tree } from 'antd'
import styled from 'styled-components'
import theme from 'live/services/theme'
import 'antd/lib/tree/style/index.css'

const Wrapper = styled.div`
    overflow-y: auto;
    background: var(--gray-200);
    padding: 4px;

    .ant-tree-list-holder-inner {
        background: var(--gray-200);
    }

    .ant-tree-title,
    .ant-tree-switcher {
        font-family: ${theme['font-regular']};
        font-style: normal;
        font-weight: 600;
        font-size: 11px;
        line-height: 12px;
        color: var(--text-color);
    }

    .ant-tree {
        margin-bottom: 1px;
    }

    .ant-tree-node-content-wrapper {
        height: 12px;
        width: 100%;
        background: var(--gray-100);
        border: 1px solid var(--gray-400);
        :hover {
            border: 1px solid var(--blue-500);
            color: var(--text-color);
            /* background: var(--gray-200); */
        }
    }

    .ant-tree-treenode {
        padding-bottom: 0px;
        width: 100%;
    }

    .ant-tree-title {
        line-height: 24px;
        vertical-align: top;
    }
    .ant-tree .ant-tree-node-content-wrapper:hover {
        background: var(--blue-200);
    }
    .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
        border: 1px solid var(--blue-500);
        color: var(--text-color);
        background: var(--blue-200);
    }
    .ant-tree-switcher {
        padding-top: 7px;
    }
    .ant-tree-checkbox {
        margin: 6px 4px 0px 0px;

        .ant-tree-checkbox-inner {
            font-size: 12px;
            width: 12px;
            height: 12px;
        }
    }
    span:not(.ant-tree-checkbox-indeterminate) {
        .ant-tree-checkbox-inner::after {
            width: 4.2855px;
            height: 6.85725px;
            border: 1.5px solid #fff;
            border-top: 0px;
            border-left: 0px;
        }
    }
`

// width: 481px;
// max-height: 514px;

const TreeStyled: React.FC<{
    defaultExpandedKeys: Array<React.Key>
    onSelect: (e: Array<string>) => void
    onCheck: (e: Array<string>) => void
    treeData: interventionDataTypes[]
    checkedKeys: React.Key[]
    checkable: undefined | boolean
    selectedKeys: React.Key[]
}> = props => {
    return (
        <Wrapper>
            {props.checkable ? (
                <Tree
                    checkable
                    defaultExpandedKeys={props.defaultExpandedKeys}
                    defaultSelectedKeys={[]}
                    defaultCheckedKeys={[]}
                    onSelect={props.onSelect}
                    onCheck={props.onCheck}
                    treeData={props.treeData}
                    checkedKeys={props.checkedKeys}
                    selectedKeys={props.selectedKeys}
                />
            ) : (
                <Tree
                    defaultExpandedKeys={props.defaultExpandedKeys}
                    defaultSelectedKeys={[]}
                    onSelect={props.onSelect}
                    treeData={props.treeData}
                    selectedKeys={props.selectedKeys}
                />
            )}
        </Wrapper>
    )
}

export default TreeStyled
